<template>
    <div>
        <apexchart class="log-chart" width="98%" height="300px" type="line" :series="[...seriesIn]"
                   :options="options"></apexchart>
    </div>
</template>

<script>
import moment from "moment";

export default {
    props: {
        seriesIn: Array,
    },
    name: 'design-2021-log-apex-component',
    data() {
        return {
            options: {
                chart: {
                    id: 'Logbook-chart',
                    type: 'line',
                    toolbar: {
                        show: false
                    },
                },
                xaxis: {
                    type: 'datetime',
                    labels: {
                        format: 'dd/MM'
                    }
                },
                yaxis: {
                    min: 0,
                },
                tooltip: {
                    x: {
                        format: 'dd MMM yyyy'
                    }
                },
                stroke: {
                    curve: 'smooth'
                },
                dataLabels: {
                    enabled: true,
                }
            },
            dataLabels: {
                enabled: false
            },
            series: [...this.seriesIn]
        }
    },

    methods: {
        createSeries() {
            this.series = [];

            for (var i = 0; i < this.logitems.length; i++) {
                var found = false;

                for (var j = 0; j < this.series.length; j++) {
                    if (this.series[j].name == this.logitems[i].name) {
                        found = true;
                        this.series[j].data.push([this.logitems[i].timestamp * 1000, this.logitems[i].timestampdifferences]);
                    }
                }

                if (!found) {
                    this.series.push(this.firstItem(this.logitems[i]));

                    this.series[this.series.length - 1].data.push(this.getData(this.logitems[i]));

                    // this.series[this.series.length - 1].data.push([this.logitems[i].timestamp*1000, this.logitems[i].timestampdifferences]);
                }
            }
        },

        firstItem(logItem) {
            let date = moment(String(logItem.date_time)).subtract(1, 'day').format('YYYY-MM-DD h:mm:ss');

            let name = logItem.name;
            let timestamp = moment(date).format('X');
            let timestampdifferences = 0;

            return {name: name, data: [[timestamp, timestampdifferences]]};
        },

        getData(logItem) {
            let totalHours = 0;
            let totalMinutes = 0;

            let differences = null;

            let logSplit = logItem.difference.split(' ');

            if (logSplit.length === 4) {
                totalMinutes = totalMinutes + parseInt(logSplit[2]);
                totalHours = totalHours + parseInt(logSplit[0]);

                if (totalMinutes > 60) {
                    totalHours = totalHours + 1;
                    totalMinutes = totalMinutes - 60;
                }

                differences = totalHours + ' uur, ' + totalMinutes + ' min';
            } else {
                if (logSplit[1] === 'min') {
                    totalMinutes = totalMinutes + parseInt(logSplit[0]);

                    if (totalMinutes > 60) {
                        totalHours = totalHours + 1;
                        totalMinutes = totalMinutes - 60;
                    }
                } else {
                    totalHours = totalHours + parseInt(logSplit[0]);
                }

                differences = totalHours + ' uur';
            }

            let total = totalHours + ',' + totalMinutes;
            let timestampdifferences = Math.round(parseInt(total));

            return [logItem.timestamp * 1000, timestampdifferences];
        },
    },
    watch: {
        seriesIn: function (value) {
            this.series = value;
        }
    }
}
</script>

<style scoped>

.log-chart {
    margin-top: 50px;
}

</style>
